export const namedColors = [
    { "name": "aliceblue", "RGB": "#f0f8ff" },
    { "name": "antiquewhite", "RGB": "#faebd7" },
    { "name": "aqua", "RGB": "#00ffff" },
    { "name": "aquamarine", "RGB": "#7fffd4" },
    { "name": "azure", "RGB": "#f0ffff" },
    { "name": "beige", "RGB": "#f5f5dc" },
    { "name": "bisque", "RGB": "#ffe4c4" },
    { "name": "black", "RGB": "#000000" },
    { "name": "blanchedalmond", "RGB": "#ffebcd" },
    { "name": "blue", "RGB": "#0000ff" },
    { "name": "blueviolet", "RGB": "#8a2be2" },
    { "name": "brown", "RGB": "#a52a2a" },
    { "name": "burlywood", "RGB": "#deb887" },
    { "name": "cadetblue", "RGB": "#5f9ea0" },
    { "name": "chartreuse", "RGB": "#7fff00" },
    { "name": "chocolate", "RGB": "#d2691e" },
    { "name": "coral", "RGB": "#ff7f50" },
    { "name": "cornflowerblue", "RGB": "#6495ed" },
    { "name": "cornsilk", "RGB": "#fff8dc" },
    { "name": "crimson", "RGB": "#dc143c" },
    { "name": "cyan", "RGB": "#00ffff" },
    { "name": "darkblue", "RGB": "#00008b" },
    { "name": "darkcyan", "RGB": "#008b8b" },
    { "name": "darkgoldenrod", "RGB": "#b8860b" },
    { "name": "darkgray", "RGB": "#a9a9a9" },
    { "name": "darkgreen", "RGB": "#006400" },
    { "name": "darkkhaki", "RGB": "#bdb76b" },
    { "name": "darkmagenta", "RGB": "#8b008b" },
    { "name": "darkolivegreen", "RGB": "#556b2f" },
    { "name": "darkorange", "RGB": "#ff8c00" },
    { "name": "darkorchid", "RGB": "#9932cc" },
    { "name": "darkred", "RGB": "#8b0000" },
    { "name": "darksalmon", "RGB": "#e9967a" },
    { "name": "darkseagreen", "RGB": "#8fbc8f" },
    { "name": "darkslateblue", "RGB": "#483d8b" },
    { "name": "darkslategray", "RGB": "#2f4f4f" },
    { "name": "darkturquoise", "RGB": "#00ced1" },
    { "name": "darkviolet", "RGB": "#9400d3" },
    { "name": "deeppink", "RGB": "#ff1493" },
    { "name": "deepskyblue", "RGB": "#00bfff" },
    { "name": "dimgray", "RGB": "#696969" },
    { "name": "dodgerblue", "RGB": "#1e90ff" },
    { "name": "firebrick", "RGB": "#b22222" },
    { "name": "floralwhite", "RGB": "#fffaf0" },
    { "name": "forestgreen", "RGB": "#228b22" },
    { "name": "fuchsia", "RGB": "#ff00ff" },
    { "name": "gainsboro", "RGB": "#dcdcdc" },
    { "name": "ghostwhite", "RGB": "#f8f8ff" },
    { "name": "gold", "RGB": "#ffd700" },
    { "name": "goldenrod", "RGB": "#daa520" },
    { "name": "gray", "RGB": "#808080" },
    { "name": "green", "RGB": "#008000" },
    { "name": "greenyellow", "RGB": "#adff2f" },
    { "name": "honeydew", "RGB": "#f0fff0" },
    { "name": "hotpink", "RGB": "#ff69b4" },
    { "name": "indianred ", "RGB": "#cd5c5c" },
    { "name": "indigo", "RGB": "#4b0082" },
    { "name": "ivory", "RGB": "#fffff0" },
    { "name": "khaki", "RGB": "#f0e68c" },
    { "name": "lavender", "RGB": "#e6e6fa" },
    { "name": "lavenderblush", "RGB": "#fff0f5" },
    { "name": "lawngreen", "RGB": "#7cfc00" },
    { "name": "lemonchiffon", "RGB": "#fffacd" },
    { "name": "lightblue", "RGB": "#add8e6" },
    { "name": "lightcoral", "RGB": "#f08080" },
    { "name": "lightcyan", "RGB": "#e0ffff" },
    { "name": "lightgoldenrodyellow", "RGB": "#fafad2" },
    { "name": "lightgrey", "RGB": "#d3d3d3" },
    { "name": "lightgreen", "RGB": "#90ee90" },
    { "name": "lightpink", "RGB": "#ffb6c1" },
    { "name": "lightsalmon", "RGB": "#ffa07a" },
    { "name": "lightseagreen", "RGB": "#20b2aa" },
    { "name": "lightskyblue", "RGB": "#87cefa" },
    { "name": "lightslategray", "RGB": "#778899" },
    { "name": "lightsteelblue", "RGB": "#b0c4de" },
    { "name": "lightyellow", "RGB": "#ffffe0" },
    { "name": "lime", "RGB": "#00ff00" },
    { "name": "limegreen", "RGB": "#32cd32" },
    { "name": "linen", "RGB": "#faf0e6" },
    { "name": "magenta", "RGB": "#ff00ff" },
    { "name": "maroon", "RGB": "#800000" },
    { "name": "mediumaquamarine", "RGB": "#66cdaa" },
    { "name": "mediumblue", "RGB": "#0000cd" },
    { "name": "mediumorchid", "RGB": "#ba55d3" },
    { "name": "mediumpurple", "RGB": "#9370d8" },
    { "name": "mediumseagreen", "RGB": "#3cb371" },
    { "name": "mediumslateblue", "RGB": "#7b68ee" },
    { "name": "mediumspringgreen", "RGB": "#00fa9a" },
    { "name": "mediumturquoise", "RGB": "#48d1cc" },
    { "name": "mediumvioletred", "RGB": "#c71585" },
    { "name": "midnightblue", "RGB": "#191970" },
    { "name": "mintcream", "RGB": "#f5fffa" },
    { "name": "mistyrose", "RGB": "#ffe4e1" },
    { "name": "moccasin", "RGB": "#ffe4b5" },
    { "name": "navajowhite", "RGB": "#ffdead" },
    { "name": "navy", "RGB": "#000080" },
    { "name": "oldlace", "RGB": "#fdf5e6" },
    { "name": "olive", "RGB": "#808000" },
    { "name": "olivedrab", "RGB": "#6b8e23" },
    { "name": "orange", "RGB": "#ffa500" },
    { "name": "orangered", "RGB": "#ff4500" },
    { "name": "orchid", "RGB": "#da70d6" },
    { "name": "palegoldenrod", "RGB": "#eee8aa" },
    { "name": "palegreen", "RGB": "#98fb98" },
    { "name": "paleturquoise", "RGB": "#afeeee" },
    { "name": "palevioletred", "RGB": "#d87093" },
    { "name": "papayawhip", "RGB": "#ffefd5" },
    { "name": "peachpuff", "RGB": "#ffdab9" },
    { "name": "peru", "RGB": "#cd853f" },
    { "name": "pink", "RGB": "#ffc0cb" },
    { "name": "plum", "RGB": "#dda0dd" },
    { "name": "powderblue", "RGB": "#b0e0e6" },
    { "name": "purple", "RGB": "#800080" },
    { "name": "rebeccapurple", "RGB": "#663399" },
    { "name": "red", "RGB": "#ff0000" },
    { "name": "rosybrown", "RGB": "#bc8f8f" },
    { "name": "royalblue", "RGB": "#4169e1" },
    { "name": "saddlebrown", "RGB": "#8b4513" },
    { "name": "salmon", "RGB": "#fa8072" },
    { "name": "sandybrown", "RGB": "#f4a460" },
    { "name": "seagreen", "RGB": "#2e8b57" },
    { "name": "seashell", "RGB": "#fff5ee" },
    { "name": "sienna", "RGB": "#a0522d" },
    { "name": "silver", "RGB": "#c0c0c0" },
    { "name": "skyblue", "RGB": "#87ceeb" },
    { "name": "slateblue", "RGB": "#6a5acd" },
    { "name": "slategray", "RGB": "#708090" },
    { "name": "snow", "RGB": "#fffafa" },
    { "name": "springgreen", "RGB": "#00ff7f" },
    { "name": "steelblue", "RGB": "#4682b4" },
    { "name": "tan", "RGB": "#d2b48c" },
    { "name": "teal", "RGB": "#008080" },
    { "name": "thistle", "RGB": "#d8bfd8" },
    { "name": "tomato", "RGB": "#ff6347" },
    { "name": "turquoise", "RGB": "#40e0d0" },
    { "name": "violet", "RGB": "#ee82ee" },
    { "name": "wheat", "RGB": "#f5deb3" },
    { "name": "white", "RGB": "#ffffff" },
    { "name": "whitesmoke", "RGB": "#f5f5f5" },
    { "name": "yellow", "RGB": "#ffff00" },
    { "name": "yellowgreen", "RGB": "#9acd32" }
];